import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/advantage',
    name: 'advantage',
    component: () => import(/* webpackChunkName: "advantage" */ '../views/Advantage.vue'),
  },
  {
    path: '/introduction',
    name: 'introduction',
    component: () => import(/* webpackChunkName: "introduction" */ '../views/Introduction.vue'),
  },
  {
    path: '/caseinsight',
    name: 'caseinsight',
    component: () => import(/* webpackChunkName: "caseinsight" */ '../views/Caseinsight.vue'),
  },
  {
    path: '/advertising',
    name: 'advertising',
    component: () => import(/* webpackChunkName: "advertising" */ '../views/Advertising.vue'),
  },
  {
    path: '/marketing',
    name: 'marketing',
    component: () => import(/* webpackChunkName: "marketing" */ '../views/Marketing.vue'),
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact" */ '../views/Contact.vue'),
  },
  {
    path: '/news',
    name: 'news',
    component: () => import(/* webpackChunkName: "news" */ '../views/News.vue'),
  },
  {
    path: '/agent',
    name: 'agent',
    component: () => import(/* webpackChunkName: "agent" */ '../views/Agent.vue'),
  },
  {
    path: '/localization',
    name: 'localization',
    component: () => import(/* webpackChunkName: "localization" */ '../views/Localization.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
